import React from 'react';
import {Route} from 'react-router';
import {BrowserRouter} from 'react-router-dom';
import Index from './components/home/Index'

const AppRoute = () =>{
    return(
        <BrowserRouter>
            <div>
                <Route exact path="/" component={Index} />
            </div>
        </BrowserRouter>
    )
};

export default AppRoute


// WEBPACK FOOTER //
// ./src/Route.js